import { render } from "./SelectBoxComponent.vue?vue&type=template&id=56e6d106"
import script from "./SelectBoxComponent.vue?vue&type=script&lang=js"
export * from "./SelectBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__